import { useSelector } from "react-redux";

const PermissionWrapper = ({ extraProps, additionalPermission = true, children, noPermissionChild=null }) => {
    const { permission } = useSelector((state) => state.leases);
    const parentPermission = permission?.permissions?.lease_revamp_application?.[extraProps?.application]?.[extraProps?.feature];
    const featurePermission = Array.isArray(extraProps?.operationType)
        ? extraProps.operationType
        : [];

    if (featurePermission?.some(element => parentPermission?.includes(element)) && additionalPermission) {
        return children ?? null
    }else{
      return  noPermissionChild ?? null
    }
}
export default PermissionWrapper;